module.exports = __webpack_public_path__ + "static/media/about-us.c0c14ee9.svg";